// import React, { useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Eye, EyeOff, User, Lock } from 'lucide-react';
// import axios from 'axios';
// import api from '../api';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import gecimo_logo from '../image/gecimo_logo.jpg'; // Assurez-vous que le chemin est correct
// import gecimo_login from '../image/gecimo_login.jpg'; // Assurez-vous que le chemin est correct

// const Login = () => {
//   const [login, setLogin] = useState('');
//   const [password, setPassword] = useState('');
//   const [errors, setErrors] = useState({ login: '', password: '' });
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     let hasError = false;
//     const newErrors = { login: '', password: '' };

//     if (!login) {
//       newErrors.login = 'Le login est requis.';
//       hasError = true;
//     }
//     if (!password) {
//       newErrors.password = 'Le mot de passe est requis.';
//       hasError = true;
//     }

//     setErrors(newErrors);

//     if (hasError) return;

//     try {
//       const formData = new FormData();
//       formData.append('login', login);
//       formData.append('mote_de_passe', password);

//       const response = await api.post('/login',formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       );

//       const data = response.data;

//       if (data.success) {
//         const { utilisateur_id, organisation_id, role_id, module_id, email } = data.user;

//         localStorage.setItem('utilisateur_id', utilisateur_id);
//         localStorage.setItem('organisation_id', organisation_id);
//         localStorage.setItem('role_id', role_id);
//         localStorage.setItem('module_id', module_id);
//         localStorage.setItem('email', email);

//         // Convertir role_id en nombre pour éviter les problèmes de type
//         const roleIdNumber = parseInt(role_id);

//         // Vérifier s'il y a une URL de redirection stockée
//         const from = location.state?.from?.pathname;

//         // Routes par défaut pour chaque rôle
//         const roleRoutes = {
//           1: '/client/home',
//           2: '/admin',
//           3: '/ChefProjet/home',
//           4: '/technique/home',
//           5: '/fonctionelle/home',
//           6: '/admin-client/home',
//           7: '/super-admin/home',
//           8: '/dg/demande'
//         };

//         // Déterminer le chemin de redirection
//         let redirectPath;

//         if (from) {
//           // Vérifier si l'utilisateur a le bon rôle pour accéder à la page demandée
//           const isAuthorized = checkRoleAuthorization(from, roleIdNumber);
//           if (isAuthorized) {
//             redirectPath = from;
//           } else {
//             // Si pas autorisé, rediriger vers la page par défaut du rôle
//             redirectPath = roleRoutes[roleIdNumber] || '/';
//           }
//         } else {
//           // Pas de redirection stockée, utiliser la route par défaut
//           redirectPath = roleRoutes[roleIdNumber] || '/';
//         }

//         toast.success('Connexion réussie. Bienvenue !', {
//           position: 'top-right',
//           autoClose: 500,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: false,
//           draggable: true,
//           progress: undefined
//         });

//         setTimeout(() => {
//           navigate(redirectPath);
//         }, 600);
//       } else {
//         toast.error('Login ou mot de passe incorrect.', {
//           position: 'top-right',
//           autoClose: 500
//         });
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Erreur serveur. Veuillez réessayer.', {
//         position: 'top-right',
//         autoClose: 500
//       });
//     }
//   };

//   // Fonction pour vérifier si un rôle a accès à une route
//   const checkRoleAuthorization = (path, roleId) => {
//     const rolePermissions = {
//       1: ['/client'], // Client
//       2: ['/admin'], // Admin
//       3: ['/ChefProjet'], // Chef de projet
//       4: ['/technique'], // Technique
//       5: ['/fonctionelle'], // Fonctionelle
//       6: ['/admin-client'], // Admin client
//       7: ['/super-admin'], // Super admin
//       8: ['/dg'] // DG
//     };

//     const allowedPaths = rolePermissions[roleId] || [];
//     return allowedPaths.some(allowedPath => path.startsWith(allowedPath));
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-gray-100 flex items-center justify-center p-4">
//       <div className="max-w-6xl w-full grid grid-cols-1 lg:grid-cols-2 bg-white rounded-2xl shadow-xl overflow-hidden">
//         {/* Form Side */}
//         <div className="p-8 sm:p-12 flex flex-col justify-center">
//           <div className="text-center mb-8">
//             <img
//               // src="../image/gecimo_logo.jpg"
//               src={gecimo_logo}
//               alt="Logo Gecimmo"
//               className="h-16 mx-auto mb-4 transition-transform duration-300 hover:scale-105"
//             />
//             <h2 className="text-3xl font-bold text-gray-800 mb-2">Bienvenue sur Gecimmo</h2>
//             <p className="text-gray-600">Gérez votre patrimoine immobilier en toute simplicité</p>
//           </div>

//           <form onSubmit={handleSubmit} className="space-y-6">
//             {/* Login Input */}
//             <div className="space-y-2">
//               <label htmlFor="login" className="block text-sm font-medium text-gray-700">
//                 Login
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
//                   <User size={18} />
//                 </div>
//                 <input
//                   id="login"
//                   type="text"
//                   value={login}
//                   onChange={(e) => setLogin(e.target.value)}
//                   placeholder="Entrez votre login"
//                   className={`block w-full pl-10 pr-3 py-3 rounded-lg border ${errors.login ? 'border-red-500' : 'border-gray-300'
//                     } focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200`}
//                 />
//                 {errors.login && <p className="text-sm text-red-600 mt-1">{errors.login}</p>}
//               </div>
//             </div>

//             {/* Password Input */}
//             <div className="space-y-2">
//               <label htmlFor="password" className="block text-sm font-medium text-gray-700">
//                 Mot de passe
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
//                   <Lock size={18} />
//                 </div>
//                 <input
//                   id="password"
//                   type={showPassword ? 'text' : 'password'}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Entrez votre mot de passe"
//                   className={`block w-full pl-10 pr-10 py-3 rounded-lg border ${errors.password ? 'border-red-500' : 'border-gray-300'
//                     } focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200`}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword((prev) => !prev)}
//                   className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-indigo-600 transition duration-200"
//                   aria-label={showPassword ? 'Cacher le mot de passe' : 'Afficher le mot de passe'}
//                 >
//                   {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                 </button>
//                 {errors.password && <p className="text-sm text-red-600 mt-1">{errors.password}</p>}
//               </div>
//             </div>

//             {/* Submit Button */}
//             <div className="pt-4">
//               <button
//                 type="submit"
//                 className="w-full py-3 px-4 bg-terrecuite hover:bg-gray-700 text-white font-medium rounded-lg shadow-sm transition duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
//               >
//                 Se connecter
//               </button>
//             </div>
//           </form>
//         </div>

//         {/* Graphic Side */}
//         <div className="hidden lg:block relative bg-gradient-to-br from-indigo-600 to-indigo-800">
//           <div className="absolute inset-0 bg-indigo-900/10"></div>
//           <img
//             // src="../image/gecimo_login.jpg"
//             src={gecimo_login}
//             alt="Illustration Gecimmo"
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black/60 to-transparent">
//             <h3 className="text-xl font-semibold text-white">Gestion Immobilière Intelligente</h3>
//             <p className="text-gray-200 mt-2">
//               Optimisez la gestion de votre parc immobilier avec nos outils performants
//             </p>
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </div>
//   );
// };

// export default Login;

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Eye, EyeOff, User, Lock } from 'lucide-react';
import api from '../api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import gecimo_logo from '../image/gecimo_logo.jpg';
import gecimo_login from '../image/gecimo_login.jpg';

const Login = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({ login: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation simple
    const newErrors = { login: '', password: '' };
    let hasError = false;
    if (!login) { newErrors.login = 'Le login est requis.'; hasError = true; }
    if (!password) { newErrors.password = 'Le mot de passe est requis.'; hasError = true; }
    setErrors(newErrors);
    if (hasError) return;

    try {
      // Login (cookie HttpOnly créé côté serveur)
      const formData = new FormData();
      formData.append('login', login);
      formData.append('mote_de_passe', password);

      const loginResponse = await api.post('/login', formData, { withCredentials: true });
      if (!loginResponse.data.success) {
        toast.error('Login ou mot de passe incorrect.');
        return;
      }

      // Récupérer les infos utilisateur depuis /me
      const userResponse = await api.get('/me', { withCredentials: true });
      if (!userResponse.data.success) {
        toast.error('Impossible de récupérer les informations utilisateur.');
        return;
      }

      const user = userResponse.data.user;
      const roleId = parseInt(user.role_id, 10);

      // Routes par rôle
      const roleRoutes = {
        1: '/client/home',
        2: '/admin',
        3: '/ChefProjet/home',
        4: '/technique/home',
        5: '/fonctionelle/home',
        6: '/admin-client/home',
        7: '/super-admin/home',
        8: '/dg/demande'
      };

      // Redirection : si on a une URL demandée dans location.state, vérifier l'autorisation
      const from = location.state?.from?.pathname;
      const redirectPath = from && checkRoleAuthorization(from, roleId)
        ? from
        : roleRoutes[roleId] || '/';

      toast.success('Connexion réussie !', { autoClose: 500 });
      setTimeout(() => navigate(redirectPath), 600);

    } catch (err) {
      console.error('Erreur:', err.response?.data || err);
      toast.error('Erreur serveur. Veuillez réessayer.');
    }
  };

  // Vérifie si un rôle a accès à une route
  const checkRoleAuthorization = (path, roleId) => {
    const rolePermissions = {
      1: ['/client'],
      2: ['/admin'],
      3: ['/ChefProjet'],
      4: ['/technique'],
      5: ['/fonctionelle'],
      6: ['/admin-client'],
      7: ['/super-admin'],
      8: ['/dg']
    };
    return (rolePermissions[roleId] || []).some(allowedPath => path.startsWith(allowedPath));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-6xl w-full grid grid-cols-1 lg:grid-cols-2 bg-white rounded-2xl shadow-xl overflow-hidden">
        {/* Form Side */}
        <div className="p-8 sm:p-12 flex flex-col justify-center">
          <div className="text-center mb-8">
            <img src={gecimo_logo} alt="Logo Gecimmo" className="h-16 mx-auto mb-4 transition-transform duration-300 hover:scale-105" />
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Bienvenue sur Gecimmo</h2>
            <p className="text-gray-600">Gérez votre patrimoine immobilier en toute simplicité</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Login Input */}
            <div className="space-y-2">
              <label htmlFor="login" className="block text-sm font-medium text-gray-700">Login</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400"><User size={18} /></div>
                <input
                  id="login"
                  type="text"
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                  placeholder="Entrez votre login"
                  className={`block w-full pl-10 pr-3 py-3 rounded-lg border ${errors.login ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200`}
                />
                {errors.login && <p className="text-sm text-red-600 mt-1">{errors.login}</p>}
              </div>
            </div>

            {/* Password Input */}
            <div className="space-y-2">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">Mot de passe</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400"><Lock size={18} /></div>
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Entrez votre mot de passe"
                  className={`block w-full pl-10 pr-10 py-3 rounded-lg border ${errors.password ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200`}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(prev => !prev)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-indigo-600 transition duration-200"
                  aria-label={showPassword ? 'Cacher le mot de passe' : 'Afficher le mot de passe'}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
                {errors.password && <p className="text-sm text-red-600 mt-1">{errors.password}</p>}
              </div>
            </div>

            <div className="pt-4">
              <button type="submit" className="w-full py-3 px-4 bg-terrecuite hover:bg-gray-700 text-white font-medium rounded-lg shadow-sm transition duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Se connecter</button>
            </div>
          </form>
        </div>

        {/* Graphic Side */}
        <div className="hidden lg:block relative bg-gradient-to-br from-indigo-600 to-indigo-800">
          <div className="absolute inset-0 bg-indigo-900/10"></div>
          <img src={gecimo_login} alt="Illustration Gecimmo" className="w-full h-full object-cover" />
          <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black/60 to-transparent">
            <h3 className="text-xl font-semibold text-white">Gestion Immobilière Intelligente</h3>
            <p className="text-gray-200 mt-2">Optimisez la gestion de votre parc immobilier avec nos outils performants</p>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;


